import { render, staticRenderFns } from "./RegionManagementListItem.vue?vue&type=template&id=9d0328d2"
import script from "./RegionManagementListItem.vue?vue&type=script&lang=js"
export * from "./RegionManagementListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports